import LayoutDefault from 'Components/LayoutDefault/LayoutDefault';
import React, { useEffect, useState } from 'react';
import Registration from './Registration/Registration';
import Panel from 'Components/Panel/Panel';
import Machine from './Items/Machine/Machine';
import Role from './Role/Role';
import ClothesClassification from './Items/ClothesClassification/ClothesClassification';
import FilterItems from './FilterItems/FilterItems';
import WorkPeriod from './WorkPeriod/WorkPeriod';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ReasonAbsence from './ReasonAbsence/ReasonAbsence';
import Sector from './Sector';
import Salary from './Salary';
import Benefits from './Benefits';
import Profiles from './Profiles/Profiles';
import GeneralSettings from './GeneralSettings/GeneralSettings';
import GeneralWorkHours from './GeneralWorkHours/GeneralWorkHours';
import WorkingInterval from './WorkingInterval/WorkingInterval';
import BillingDate from './BillingDate/BillingDate';
import GroupInformation from './PeopleGroup/GroupInformation';

const Configuration = () => {
    useEffect(() => {
        document.title = "Redech | Configuração"
    }, [])

    const [registrationIdsSelected, setRegistrationIdsSelected] = useState([]);
    const [isActiveFilter, setIsActiveFilter] = useState('S');

    const mainStyle = {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: '100%'
    };

    function getItemPanel(defaultFilter) {
        if (!registrationIdsSelected || registrationIdsSelected.length != 1) {
            return null
        }

        switch (registrationIdsSelected[0]) {
            case 1:
                return (
                    <>
                        {defaultFilter}
                        <Machine
                            registrationIdsSelected={registrationIdsSelected}
                            isActiveFilter={isActiveFilter}
                        />
                    </>
                )
            case 2:
                return (
                    <>
                        {defaultFilter}
                        <ClothesClassification
                            registrationIdsSelected={registrationIdsSelected}
                            isActiveFilter={isActiveFilter}
                        />
                    </>
                )
            case 3:
                return (
                    <>
                        {defaultFilter}
                        <Role
                            registrationIdsSelected={registrationIdsSelected}
                            isActiveFilter={isActiveFilter}
                        />
                    </>
                )
            case 5:
                return (
                    <>
                        {defaultFilter}
                        <WorkPeriod
                            registrationIdsSelected={registrationIdsSelected}
                            isActiveFilter={isActiveFilter}
                        />
                    </>
                )
            case 6:
                return (
                    <>
                        {defaultFilter}
                        <GeneralWorkHours
                            registrationIdsSelected={registrationIdsSelected}
                            isActiveFilter={isActiveFilter}
                        />
                    </>
                )
            case 7:
                return (
                    <>
                        <GeneralSettings
                            registrationIdsSelected={registrationIdsSelected}
                        />
                    </>
                )
            case 8:
                return (
                    <>
                        {defaultFilter}
                        <ReasonAbsence
                            registrationIdsSelected={registrationIdsSelected}
                            isActiveFilter={isActiveFilter}
                        />
                    </>
                )
            case 9:
                return (
                    <Sector />
                )
            case 10:
                return (
                    <>
                        {defaultFilter}
                        <Salary
                            registrationIdsSelected={registrationIdsSelected}
                            isActiveFilter={isActiveFilter}
                        />
                    </>

                )
            case 11:
                return (
                    <>
                        {defaultFilter}
                        <Benefits
                            registrationIdsSelected={registrationIdsSelected}
                            isActiveFilter={isActiveFilter}
                        />
                    </>
                )
            case 12:
                return (
                    <>
                        <Profiles
                            registrationIdsSelected={registrationIdsSelected}
                        />
                    </>
                )
            case 13:
                return (
                    <>
                        {defaultFilter}
                        <WorkingInterval
                            registrationIdsSelected={registrationIdsSelected}
                            isActiveFilter={isActiveFilter}
                        />
                    </>
                )
            case 14:
                return (
                    <>
                        <BillingDate
                            registrationIdsSelected={registrationIdsSelected}
                        />
                    </>
                )
            case 15:
                return (
                    <>
                        <GroupInformation
                            registrationIdsSelected={registrationIdsSelected}
                        />
                    </>
                )
            default: return null
        }
    }

    function getPanelRecords() {
        if (!registrationIdsSelected || registrationIdsSelected.length != 1) {
            return (
                <PanelListDefault isEmptyPanel={true} />
            )
        }

        const defaultFilter = (
            <FilterItems
                isActiveFilter={isActiveFilter}
                onUpdatesIsActiveFilter={setIsActiveFilter}
            />
        )

        return (
            <>
                {getItemPanel(defaultFilter)}
            </>
        )

    }

    const itemPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '5px',
        maxWidth: isTwoPanels() ? 'calc(75% - 5px)' : 'calc(75% - 15px)',
        minWidth: isTwoPanels() ? 'calc(75% - 5px)' : 'calc(75% - 15px)'
    };

    function isTwoPanels() {
        return (registrationIdsSelected && [12, 15].includes(registrationIdsSelected[0]));
    }

    return (
        <>
            <LayoutDefault>
                <Panel style={mainStyle}>
                    <Registration
                        registrationIdsSelected={registrationIdsSelected}
                        onUpdateRegistrationIdSelected={setRegistrationIdsSelected}
                    />
                    <Panel style={itemPanelStyle} 
                    className={isTwoPanels() ? 'config-content' : 'main-modal config-content'}>
                        {getPanelRecords()}
                    </Panel>
                </Panel>
            </LayoutDefault>
        </>
    );
};

export default Configuration;
